import React from 'react';
import y1 from '../assets/y1.png';
import y2 from '../assets/y2.png';
import y3 from '../assets/y3.png';
import ModernResources from './modern/ModernResources';

// Board-specific bits only; the design is shared (src/components/modern, 2026-10-02 refresh).
const RESOURCES = [
  {
    img: y1,
    title: "Canada Summer Jobs",
    text: "Summer jobs with employers across Canada, part of the Government of Canada’s Youth Employment and Skills Strategy for young people, especially those facing barriers to work.",
    href: 'https://www.canada.ca/en/employment-social-development/services/funding/canada-summer-jobs.html',
  },
  {
    img: y2,
    title: "Jobs and programs for students",
    text: "Job opportunities and Government of Canada hiring programs for students and young people.",
    href: 'https://www.canada.ca/en/services/jobs/youth.html',
  },
  {
    img: y3,
    title: "Federal Student Work Experience Program",
    text: "Apply once to be considered for full- or part-time student jobs across the federal public service (FSWEP).",
    href: 'https://www.canada.ca/en/public-service-commission/jobs/services/recruitment/students/federal-student-work-program.html',
  },
];

export default function Resources() {
  return <ModernResources items={RESOURCES} />;
}
